<template>
  <div>
    <component
      :is="question['Attribute_Type__c']"
      v-for="question in schema"
      :key="question['Id']"
      :answer="answers[question['Id']]"
      :attributeType="question['Attribute_Type__c']"
      :childOfListQuestions="childOfListQuestions[question['Id']]"
      :decimalPlaces="question['Decimal_Place__c']"
      :dependencyMap="dependencyMap"
      :dependentQuestion="dependentQuestion[question['Id']]"
      :helpText="question['Help_Text__c']"
      :label="question.Label__c"
      :length="question['Attribute_Length__c']"
      :listAnswers="listAnswers"
      :listOptions="lov"
      :multiPicklistRestriction="question['MultiPicklistRestriction__r']"
      :name="question['Name']"
      :objectId="personId"
      :options="lov[question['Id']]"
      :questionId="question['Id']"
      :requiredQuestions="requiredQuestions"
      :selectedLimit="question['Maximum_Allowed_Values__c']"
      :staticListCount="question['Number_of_Rows__c']"
      :validationsType="'personValidations'"
      @input="
        updateForm(personId + '_' + question['Id'] + '_' + question['Attribute_Type__c'], $event)
      "
      v-on="$listeners"
    >
    </component>
  </div>
</template>
<script>
  import ReadOnly from './ReadOnly';
  import Picklist from './Picklist';
  import Date from './Date';
  import Textbox from './TextBox';
  import MultiPicklist from './MultiPicklist';
  import TextArea from './TextArea';
  import Number from './Number';
  import RadioButton from './RadioButton';
  import SubSection from './SubSection';
  import Email from './Email';
  import StaticList from './StaticList';
  import StaticColumn from './StaticListComponents/StaticColumn';
  import Documents from './Documents';
  import MultiDropdown from './MultiDropdown';
  import TimePicker from './TimePicker';

  import { mapGetters, mapMutations } from 'vuex';
  import Checkbox from './Checkbox';
  import Protocol from './Protocol';

  export default {
    name: 'PersonQuestionGenerator',
    components: {
      ReadOnly,
      Picklist,
      Date,
      Textbox,
      MultiPicklist,
      Number,
      TextArea,
      RadioButton,
      SubSection,
      Email,
      StaticList,
      StaticColumn,
      Documents,
      MultiDropdown,
      TimePicker,
      Checkbox,
      Protocol,
    },
    props: [
      'schema',
      'lov',
      'personId',
      'dependencyMap',
      'answers',
      'dependentQuestion',
      'requiredQuestions',
      'childOfListQuestions',
      'listAnswers',
    ],
    data() {
      return {
        formData: {},
      };
    },
    computed: {
      ...mapGetters(['personQuestionFormData']),
    },
    destroyed() {
      this.$store.commit('dirtyPersonSurvey', false);
      this.setPersonQuestionFormData(null);
    },
    methods: {
      ...mapMutations({
        setPersonQuestionFormData: 'personQuestionFormData',
      }),
      updateForm(fieldName, value) {
        if (fieldName.split('_')[2] === 'StaticList') {
          for (let i = 0; i < Object.keys(value).length; i++) {
            this.$set(this.formData, Object.keys(value)[i], Object.values(value)[i]);
          }
        } else {
          this.$set(this.formData, fieldName, value);
        }
        let personQuestionData = Object.assign(this.formData, this.personQuestionFormData);
        this.setPersonQuestionFormData(personQuestionData);
      },
    },
  };
</script>
